
console.log('quotes.js');
let mwUrl = typeof ArborSciConfig !== 'undefined' && ArborSciConfig.middlewareUrl ? ArborSciConfig.middlewareUrl : 'https://quotes.arborsci.com';
var Quote = {};
//Quote.endpoint = "https://arbor.test/api/";
Quote.endpoint = mwUrl + "/api/";
// Quote.endpoint = "https://arborquote.converteverywhere.com/api/";

/**
 * Centralized helper for Shopify storefront cart endpoints (/cart/*.js).
 * Uses fetch (not jQuery) so non-2xx bodies are never eval'd as scripts, and
 * surfaces Shopify throttling (429/503) as a typed error the caller can handle.
 */
async function cartApi(url, { method = 'GET', body } = {}) {
    const res = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: body ? JSON.stringify(body) : undefined
    });

    if (res.status === 429 || res.status === 503) {
        const err = new Error('Shopify cart is throttled');
        err.code = 'THROTTLED';
        err.retryAfter = parseInt(res.headers.get('retry-after') || '0', 10) || 0;
        throw err;
    }

    if (!res.ok) {
        const err = new Error('Cart request failed');
        err.code = 'CART_ERROR';
        err.status = res.status;
        throw err;
    }

    return res.json();
}

/**
 * Feature flag: when the page is opened without ?mv=1, shipping rates are read from
 * the storefront cart endpoints instead of the middleware's quote/calculate response (availableShippingRates).
 * Default (no flag) keeps the existing storefront flow.
 */
function mwRatesEnabled() {
    try {
        return new URLSearchParams(window.location.search).get('mv') != '0';
    } catch (e) {
        return false;
    }
}


if($('#quote-checkout').length > 0) {

    var priceFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    var quoteCheckoutApp = new Vue({
        el: '#quote-checkout',
        delimiters: ['${', '}'],
        data() {
            return {
                loading: false,
                step: 1,
                items: [],
                tax: 0,
                subtotal: 0,
                discount: 0,
                taxExempt: $('#quote-checkout').attr('data-exempt') ? true : false,
                customerId: $('#quote-checkout').attr('data-customer-id'),
                shipAmount: 0,
                shipName: '',
                shipCode: '',
                email: $('#quote-checkout').attr('data-customer-email'),
                invalidEmail: false,
                emailEntered: false,
                instructions: '',
                role: '',
                roleDetail: '',
                interests: [
                    { label: 'Physics', value: 'P' },
                    { label: 'Physical Science', value: 'PS' },
                    { label: 'Chemistry', value: 'C' },
                    { label: 'Earth and Space Science', value: 'ESS' },
                    { label: 'STEM', value: 'STEM' },
                    { label: 'Environmental Science', value: 'ENV' },
                    { label: 'Astronomy', value: 'ASTRO' },
                    { label: 'Math', value: 'M' },
                    { label: 'Other', value: 'O' }
                ],
                isChecked: {},
                roleDetailTextInput: '',
                roleDetailCheckboxInput: '',
                timeframe: '',
                quote: false,
                accountMessage: '',
                submitting: false,
                billingStates: [],
                shippingStates: [],
                selectedBilling: '',
                selectedShipping: '',
                requiresShipping: true,
                marketing:false,
                rateError: false,
                signupMessage: '',
                billing: {
                    first_name: '',
                    last_name: '',
                    company: '',
                    address: '',
                    address2: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'United States',
                    phone: '',
                },
                shipping: {
                    sameAsBilling: true,
                    first_name: '',
                    last_name: '',
                    company: '',
                    address: '',
                    address2: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'United States',
                    phone: '',
                },
                rates: [],
                rate: false
            }
        },
        computed: {
            selectedInterests() {
                return selectedValues = this.interests.map((interest, index) => {
                    return this.isChecked[interest.value] ? interest.value + (index === this.interests.length - 1 ? '' : '/') : '/';
                }).join('');
            }
        },
        methods: {
            validateEmail (email) {
               return String(email)
                .toLowerCase()
                .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
            },
            sameAsBillingChanged() {
                setTimeout(function() {
                    Quote.checkBillingState();
                });
            },
            contactReady() {
                let invalidEmail = false;
                if(!this.validateEmail(this.email.trim())) {
                    invalidEmail = true;
                }

                this.invalidEmail = invalidEmail && this.emailEntered;
                return !this.invalidEmail && (this.email || this.emailEntered) && this.role.trim() != '' &&
                    (['Purchasing/Administrative', 'Teacher/Professor', 'Lab Supervisor'].indexOf(this.role) < 0 ||  this.roleDetail.trim() != '');
            },
            checkEmail() {
                this.emailEntered = true;
            },
            billingReady() {
                return this.shipping.sameAsBilling ||
                    this.billing.first_name.trim() != '' &&
                    this.billing.last_name.trim() != '' &&
                    this.billing.address.trim() != '' &&
                    this.billing.city.trim() != '' &&
                    (this.billingStates.length == 0 || this.billing.state.trim() != '') &&
                    this.billing.zip.trim() != '' &&
                    this.billing.country.trim() != '' &&
                    this.billing.phone.trim() != '';
            },
            shippingReady() {
                return this.shipping.first_name.trim() != '' &&
                    this.shipping.last_name.trim() != '' &&
                    this.shipping.address.trim() != '' &&
                    this.shipping.city.trim() != '' &&
                    (this.shippingStates.length == 0 || this.shipping.state.trim() != '') &&
                    this.shipping.zip.trim() != '' &&
                    this.shipping.country.trim() != '' &&
                    this.shipping.phone.trim() != '';
            },
            containsOnlySlashes(str) {
                return /^\/+$/.test(str);
            },
            roleChanged() {
                this.marketing = ['Teacher/Professor', 'Lab Supervisor', 'Homeschool'].indexOf(this.role) >= 0;

                if (['Teacher/Professor', 'Lab Supervisor', 'Homeschool'].indexOf(this.role) >= 0) {
                    this.roleDetail = this.roleDetailCheckboxInput;
                } else {
                    this.roleDetail = this.roleDetailTextInput;
                }
            },
            changeRoleInput() {
                if (['Teacher/Professor', 'Lab Supervisor', 'Homeschool'].indexOf(this.role) >= 0) {
                    this.roleDetailCheckboxInput = this.roleDetail;
                } else {
                    this.roleDetailTextInput = this.roleDetail;
                }
            },
            updateHiddenInput() {
                this.$nextTick(() => {
                    const checkboxValue = this.containsOnlySlashes(this.selectedInterests) ? '' : this.selectedInterests;
                    this.$refs.hiddenInput.value = checkboxValue;
                    this.roleDetail = checkboxValue;
                });
            },
            goToBilling() {
                console.log('got to billing');
                this.step = 3;
                window.scrollTo(0, 0);
                Quote.checkBillingState();
            },
            billingChanged() {
                console.log("bc1", this.selectedBilling);
                if(this.selectedBilling) {
                    let $elem = $('#select-billing option:selected');
                    this.billing.first_name = $elem.attr('data-first');
                    this.billing.last_name = $elem.attr('data-last');
                    this.billing.company = $elem.attr('data-company');
                    this.billing.address = $elem.attr('data-address1');
                    this.billing.address2 = $elem.attr('data-address2');
                    this.billing.city = $elem.attr('data-city');
                    this.billing.state = $elem.attr('data-state');
                    this.billing.zip = $elem.attr('data-zip');
                    this.billing.country = $elem.attr('data-country');
                    this.billing.phone = $elem.attr('data-phone');
                }

                setTimeout(function() {
                    let $required = $('#billing-address .required');
                    $required.removeClass('missing');
                    $required.each(function() {
                        if($(this).val() == '')
                            $(this).addClass('missing');
                    });

                    Quote.checkBillingState();
                }, 1);

            },
            shippingChanged() {
                if(this.selectedShipping) {
                    let $elem = $('#select-shipping option:selected');
                    this.shipping.first_name = $elem.attr('data-first');
                    this.shipping.last_name = $elem.attr('data-last');
                    this.shipping.company = $elem.attr('data-company');
                    this.shipping.address = $elem.attr('data-address1');
                    this.shipping.address2 = $elem.attr('data-address2');
                    this.shipping.city = $elem.attr('data-city');
                    this.shipping.state = $elem.attr('data-state');
                    this.shipping.zip = $elem.attr('data-zip');
                    this.shipping.country = $elem.attr('data-country');
                    this.shipping.phone = $elem.attr('data-phone');
                }

                setTimeout(function() {
                    let $required = $('#shipping-address .required');
                    $required.removeClass('missing');
                    $required.each(function() {
                        if($(this).val() == '')
                            $(this).addClass('missing');
                    });

                    Quote.checkShippingState();
                }, 1);
            },
            goToShipping() {
                this.step = 2;
                window.scrollTo(0, 0);
                Quote.checkShippingState();
            },
            getTaxable() {
                let taxable = 0;
                for(var i = 0; i < this.items.length; i++) {
                    let item = this.items[i];
                    if(item.requires_shipping)
                        taxable += parseFloat(item.discounted_price) * item.quantity;
                }

                return taxable;
            },
            goToShipMethods(selectedMethod = null) {
                let vm = this;
                vm.loading = true;

                const shipping = this.shipping;

                const nextStep = () => {
                    let requiresShipping = false;
                    vm.items.map(i => {
                        if(i.requires_shipping)
                            requiresShipping = true;
                    });

                    vm.requiresShipping = requiresShipping;

                    console.log("gotoship");
                    if(requiresShipping) {
                        Quote.getShippingRates(shipping, (function (rates) {
                            let filtered = [];
                            rates.map(r => {
                                if(shipping.address.indexOf("po") >= 0 && shipping.address.indexOf("box") >= 0) {
                                    if(r.name.toLowerCase().indexOf("ups") >= 0)
                                        return;
                                }

                                filtered.push(r);
                            });

                            vm.rates = filtered;
                            for(var i = 0; i < vm.rates.length; i++) {
                                let rate = vm.rates[i];
                                let idx = rate.name.indexOf('(Est');
                                if(idx > 0) {
                                    vm.rates[i].name = rate.name.substring(0, idx);
                                }
                            }
                            if(rates.length > 0) {
                                const selectedRate = vm.rates.find(r => r.code == this.rate.code) || vm.rates[0];

                                vm.shipName = selectedRate.name;
                                vm.shipCode = selectedRate.code;
                                vm.shipAmount = parseFloat(selectedRate.price).toFixed(2);
                            }
                            vm.step = 4;
                            vm.loading = false;
                            window.scrollTo(0, 0);
                        }).bind(this));
                    }
                    else {
                        vm.step = 4;
                        vm.loading = false;
                        window.scrollTo(0, 0);
                    }
                }

                const items = [];
                vm.items.map(i => {
                    if(i && !i.is_digital && i.variant_id) {
                        items.push(
                            {
                                variantId: i.variant_id,
                                quantity: parseInt(i.quantity),
                                priceOverride: {
                                    amount: Number(i.discounted_price / 100).toFixed(2),
                                    currencyCode: "USD"
                                }
                            }
                        );
                    } else if (i) {
                        items.push(
                            {
                                sku: i.sku,
                                title: i.title,
                                originalUnitPrice: i.original_line_price,
                                quantity: parseInt(i.quantity),
                                requiresShipping: i.requires_shipping,
                                priceOverride: {
                                    amount: Number(i.discounted_price / 100).toFixed(2),
                                    currencyCode: "USD"
                                }
                            }
                        );
                    }
                });

                const processCalculation = async () => {
                    const countryCode = await getCountryCodeByName(vm.shipping.country);

                    const params = {
                        lineItems: items,
                        taxExempt: vm.taxExempt,
                        shippingAddress: {
                            firstName: vm.shipping.first_name,
                            lastName: vm.shipping.last_name,
                            address1: vm.shipping.address,
                            city: vm.shipping.city,
                            provinceCode: getProvinceCode(vm.shipping.state),
                            countryCode: countryCode,
                            zip: vm.shipping.zip,
                            phone: vm.shipping.phone
                        }
                    };

                    if (selectedMethod !== null && selectedMethod && selectedMethod.title) {
                        params.shippingLine = selectedMethod;
                    }

                    fetch(Quote.endpoint + 'quote/calculate', {
                        method: "POST",
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(params)
                    })
                    .then(response => response.json())
                    .then(response => {
                        this.tax = response.totalTaxSet.presentmentMoney.amount;
                        nextStep();
                    })
                    .catch(error => {
                        console.log('Error: ' + error);
                        let tax = 0;
                        if(!this.taxExempt) {
                            this.tax = 0;
                        }
                        nextStep();
                    });
                };

                processCalculation().catch(error => {
                    console.error('Error: ' + error);
                    if(!vm.taxExempt) {
                        vm.tax = 0;
                    }
                    nextStep();
                });
            },
            isReady() {
                return this.rate || !this.requiresShipping ? true : false
            },
            selectRate(rate) {
                this.rate = rate;
                this.shipName = this.rate.name;
                this.shipCode = this.rate.code;
                this.shipAmount = parseFloat(this.rate.price).toFixed(2);
                this.goToShipMethods({
                    title: this.rate.name,
                    priceWithCurrency: {
                        amount: this.rate.price,
                        currencyCode: this.rate.currency
                    }
                });
            },
            completeQuote() {
                Quote.completeQuote();
            },
            completeQuoteTest() {
                Quote.completeQuoteTest();
            },
            formatMoney(p) {
                return priceFormatter.format(p/100);
            }
        }
    });

    Quote.checkBillingState = function() {
        const provinces = $('#billing-country option:selected').attr('data-provinces');
        console.log('cbs');

        const stateList = [];
        if(provinces) {
            const states = JSON.parse(provinces);
            console.log('states', states);
            states.map(s => {
                stateList.push(s[0]);
            });
        }

        quoteCheckoutApp.billingStates = stateList;
    }

    Quote.checkShippingState = function() {
        const provinces = $('#shipping-country option:selected').attr('data-provinces');
        const stateList = [];

        console.log('css');
        if(provinces) {
            const states = JSON.parse(provinces);
            console.log('states', states);
            states.map(s => {
                stateList.push(s[0]);
            });
        }

        quoteCheckoutApp.shippingStates = stateList;
    }

    Quote.init = function() {
        fetch('/cart.json')
        .then(r => r.json())
        .then(cart =>
        {
            quoteCheckoutApp.items = cart.items;
            quoteCheckoutApp.subtotal = cart.total_price;
            quoteCheckoutApp.discount = cart.total_discount;
        });

        $('body').on('change', '#billing-country', function() {
            quoteCheckoutApp.billing.state = '';
            Quote.checkBillingState();
        });

        $('body').on('change', '#shipping-country', function() {
            quoteCheckoutApp.shipping.state = '';
            Quote.checkShippingState();
        });
    }

    Quote.getShippingRates = function(shipping, callback) {

        console.log('shipping', shipping);
        quoteCheckoutApp.rateError = false;

        let shipping_address = {
            shipping_address: {
                zip: shipping.zip,
                country: shipping.country,
                province: shipping.state
            }
        };

        $.ajax({
            type: "GET",
            dataType: "json",
            url: "/cart/shipping_rates.js",
            data: shipping_address,
            success: function (resp) {
                callback(resp.shipping_rates);
            },
            error: function () {
                quoteCheckoutApp.rateError = true;
            }
        })
    }

    Quote.completeQuoteTest = function() {
        fetch(`/cart.js`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
		.then((response) => response.json())
		.then((response) => {
			if (response) {
				let existingAttributes = response.attributes;
                let cart_generated_by = null;
                let builder_id = null;
                let builder_save_id = null;

                if (existingAttributes) {
                    if ('_cart_generated_by' in existingAttributes) {
                        cart_generated_by = existingAttributes._cart_generated_by;
                    }

                    if ('_builder_id' in existingAttributes) {
                        builder_id = Number(existingAttributes._builder_id);
                    }

                    if ('_builder_save_id' in existingAttributes) {
                        builder_save_id = Number(existingAttributes._builder_save_id);
                    }
                }

                const params = {
                    customerId: quoteCheckoutApp.customerId,
                    email: quoteCheckoutApp.email,
                    items: quoteCheckoutApp.items,
                    subtotal: quoteCheckoutApp.subtotal,
                    total: quoteCheckoutApp.subtotal + quoteCheckoutApp.shipAmount*100 + quoteCheckoutApp.tax * 100,
                    tax: quoteCheckoutApp.tax * 100,
                    discount: quoteCheckoutApp.discount,
                    shipName: quoteCheckoutApp.shipName,
                    shipCode: quoteCheckoutApp.shipCode,
                    shipAmount: quoteCheckoutApp.shipAmount,
                    instructions: quoteCheckoutApp.instructions,
                    timeframe: quoteCheckoutApp.timeframe,
                    role: quoteCheckoutApp.role,
                    roleDetail: quoteCheckoutApp.roleDetail,
                    taxExempt: quoteCheckoutApp.taxExempt,
                    billing: quoteCheckoutApp.billing,
                    shipping: quoteCheckoutApp.shipping,
                    rate: quoteCheckoutApp.rate,
                    cart_generated_by: cart_generated_by,
                    builder_id: builder_id,
                    builder_save_id: builder_save_id
                };

                quoteCheckoutApp.submitting = true;
                const klaviyObj = {
                    'Quote Created': true,
                    'quote_email': quoteCheckoutApp.email,
                    'quote_shipName': quoteCheckoutApp.shipName,
                    'quote_shipping': quoteCheckoutApp.shipping,
                    'quote_billing': quoteCheckoutApp.billing,
                    'quote_items': quoteCheckoutApp.items
                }

                function onIdentifyCompleteCallback() {
                    window.klaviyo.track('Quote Created', klaviyObj)
                }

                if (window.klaviyo) {
                    window.klaviyo.identify({
                        '$email': quoteCheckoutApp.email,
                        'Quote Created': true
                    }, undefined, undefined, onIdentifyCompleteCallback);
                }
			}
		});
    }

    Quote.completeQuote = function() {
        fetch(`/cart.js`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
		.then((response) => response.json())
		.then((response) => {
			if (response) {
				let existingAttributes = response.attributes;
                let cart_generated_by = null;
                let builder_id = null;
                let builder_save_id = null;

                if (existingAttributes) {
                    if ('_cart_generated_by' in existingAttributes) {
                        cart_generated_by = existingAttributes._cart_generated_by;
                    }

                    if ('_builder_id' in existingAttributes) {
                        builder_id = Number(existingAttributes._builder_id);
                    }

                    if ('_builder_save_id' in existingAttributes) {
                        builder_save_id = Number(existingAttributes._builder_save_id);
                    }
                }

                const params = {
                    customerId: quoteCheckoutApp.customerId,
                    email: quoteCheckoutApp.email,
                    items: quoteCheckoutApp.items,
                    subtotal: quoteCheckoutApp.subtotal,
                    total: quoteCheckoutApp.subtotal + quoteCheckoutApp.shipAmount*100 + quoteCheckoutApp.tax * 100,
                    tax: quoteCheckoutApp.tax * 100,
                    discount: quoteCheckoutApp.discount,
                    shipName: quoteCheckoutApp.shipName,
                    shipCode: quoteCheckoutApp.shipCode,
                    shipAmount: quoteCheckoutApp.shipAmount,
                    instructions: quoteCheckoutApp.instructions,
                    timeframe: quoteCheckoutApp.timeframe,
                    role: quoteCheckoutApp.role,
                    roleDetail: quoteCheckoutApp.roleDetail,
                    taxExempt: quoteCheckoutApp.taxExempt,
                    billing: quoteCheckoutApp.billing,
                    shipping: quoteCheckoutApp.shipping,
                    rate: quoteCheckoutApp.rate,
                    cart_generated_by: cart_generated_by,
                    builder_id: builder_id,
                    builder_save_id: builder_save_id
                };

                quoteCheckoutApp.submitting = true;
                $.post(Quote.endpoint + 'quotes', params, function(response) {

                    const klaviyObj = {
                        'Quote Created': true,
                        'quote_email': quoteCheckoutApp.email,
                        'quote_shipName': quoteCheckoutApp.shipName,
                        'quote_shipping': quoteCheckoutApp.shipping,
                        'quote_billing': quoteCheckoutApp.billing,
                        'quote_items': quoteCheckoutApp.items
                    }

                    function onIdentifyCompleteCallback() {
                        window.klaviyo.track('Quote Created', klaviyObj)
                    }

                    if (window.klaviyo) {
                        window.klaviyo.identify({
                            '$email': quoteCheckoutApp.email,
                            'Quote Created': true
                        }, undefined, undefined, onIdentifyCompleteCallback);
                    }

                    $.post('/cart/clear.js', function() {
                        quoteCheckoutApp.quote = response.quote;
                        quoteCheckoutApp.signupMessage = response.signup_message;
                        quoteCheckoutApp.submitting = false;

                        fetch(`/cart/update.js`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                "X-Requested-With": "XMLHttpRequest"
                            },
                            body: JSON.stringify({
                                attributes: {
                                    _cart_generated_by: "",
                                    _builder_id: "",
                                    _builder_save_id: ""
                                }
                            })
                        })
                        .then((resp) => resp.json())
                        .then((resp) => {
                            console.log('attributes clear')
                        });
                    });
                });
			}
		});
    }

    Quote.init();

    // $("body").on("click", ".ship-calc-go", function (e) {
    //     e.preventDefault();
    //     let form = $(this).closest('form')

    //     $(".input-error").removeClass('input-error');

    //     let errors = false
    //     form.find(".required:visible").each(function () {
    //         if ($.trim($(this).val()) == "") {
    //             $(this).addClass("input-error")
    //             errors = true
    //         }
    //     })

    //     if (errors) {
    //         // $(".cart-quote-input-error").show()
    //         return false
    //     }

    //     button_loading($(this));
    //     $(".cart-shipping-calc-error").hide();

    //     let $parent = $(this).closest(".cart-shipping-calc");
    //     let self = $(this);

    //     let shipping_address = {
    //         shipping_address: {
    //             zip: form.find("[name='quote[shipping_address][zip]']").val(),
    //             country: form.find("[name='quote[shipping_address][country]']").val(),
    //             province: form.find("[name='quote[shipping_address][province]']").val(),
    //         }
    //     };


    //     $.ajax({
    //         type: "GET",
    //         dataType: "json",
    //         url: "/cart/shipping_rates.js",
    //         data: shipping_address,
    //         success: function (resp) {
    //             button_reset(self);
    //             if (resp.shipping_rates.length == 0) {
    //                 $(".cart-shipping-calc-error").show();
    //                 return false;
    //             }
    //             $(".cart-shipping-calc-rates ul li").remove();
    //             $(".cart-shipping-calc-error").remove();
    //             let rate_count = 1;
    //             for (var rate of resp.shipping_rates) {

    //                 let radio = $("<input/>").attr('type', 'radio').attr('name', 'quote[rate]').val(rate.name + "|" + rate.code + "|" + rate.price).prop('checked', (rate_count++ == 1));
    //                 let label = $("<label/>").attr("for", 'quote-rate-' + rate.code).text(rate.name + " - $" + rate.price);
    //                 $(".cart-shipping-calc-rates ul").append($("<li/>").append(radio).append(label));
    //             }
    //             $(".cart-shipping-calc-input").hide();
    //             $('.billing-shipping-details').slideUp();
    //             $(".cart-shipping-calc-success").slideDown();
    //             window.scrollTo(0, 0);
    //             changeStep(3)
    //         },
    //         error: function () {
    //             $(".cart-shipping-calc-error").show();
    //             button_reset(self);
    //         }
    //     })
    // })
}

clone = function(obj) {
    if(Object.keys(obj).length === 0)
        return {};

    return JSON.parse(JSON.stringify(obj));
}

checkChanged = function(a, b, ignore) {
    if(a == null) a = '';
    if(b == null) b = '';
    if(ignore == null) ignore = [];

    if(Array.isArray(a)) {

        if(a.length != b.length)
            return true;

        // We have to do a recursive check on the array elements.
        for(let i = 0; i < a.length; i++) {
            if(this.checkChanged(a[i], b[i], ignore)) {
                return true;
            }
        }
    }

    // Do a recursive check on nested objects.
    else if(typeof a === 'object' && a != null) {

        for(let k in a) {
            if(ignore.indexOf(k) >= 0) continue;
            if(this.checkChanged(a[k], b[k], ignore))
                return true;
        }

        for(let k in b) {
            if(ignore.indexOf(k) >= 0) continue;
            if(this.checkChanged(a[k], b[k], ignore))
                return true;
        }
    }

    else if(a != b) {
        return true;
    }

    return false;
}


var Quotes = {};
//Quotes.endpoint = "https://arbor.test/api/";
Quotes.endpoint = mwUrl + "/api/";
//Quotes.endpoint = "https://arborquote.converteverywhere.com/api/";

Quotes.STATUSES = [
    'Open',
    'Awaiting Approval',
    'Confirmed – Converting',
    'Closed – Lost',
    'On Hold',
    'Completed'
];

Quotes.DEFAULT_STATUS = 'Open';
Quotes.COMPLETED_STATUS = 'Completed';

Quotes.CONCESSION_TOGGLES = [
    { key: 'special_pricing_applied', label: 'Special item pricing applied' },
    { key: 'free_freight_offered', label: 'Free freight offered' },
    { key: 'freight_reduction_applied', label: 'Freight reduction applied' },
    { key: 'extended_expiration_offered', label: 'Extended expiration date offered' }
];

Quotes.DISCOUNT_PATTERN = /^\d{1,3}(\.\d+)?$/;
Quotes.MAX_DISCOUNT = 100;

// Backend may send toggles as 0/1, "0"/"1" or booleans - keep them as 0/1.
Quotes.toToggleValue = function(value) {
    return value === true || Number(value) === 1 ? 1 : 0;
}

Quotes.cleanDiscount = function(value) {
    if(value === null || value === undefined) return '';

    return String(value).replace('%', '').trim();
}

Quotes.normalizeQuote = function(quote) {
    if(!quote) return;

    if(!quote.detail) {
        Vue.set(quote, 'detail', {});
    }

    Quotes.CONCESSION_TOGGLES.forEach(function(toggle) {
        Vue.set(quote.detail, toggle.key, Quotes.toToggleValue(quote.detail[toggle.key]));
    });

    Vue.set(quote.detail, 'overall_discount', Quotes.cleanDiscount(quote.detail.overall_discount));

    if(!quote.status) {
        Vue.set(quote, 'status', Quotes.DEFAULT_STATUS);
    }
}

Quotes.isValidDiscount = function(value) {
    const cleaned = Quotes.cleanDiscount(value);
    if(cleaned === '') return true;

    return Quotes.DISCOUNT_PATTERN.test(cleaned) && Number(cleaned) <= Quotes.MAX_DISCOUNT;
}

if($('#quotes-admin').length > 0) {

    var priceFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    var quotesCheckoutApp = new Vue({
        el: '#quotes-admin',
        delimiters: ['${', '}'],
        data() {
            return {
                role: Cookies.get('quoterole'),
                quoteEmail: '',
                quotePass: '',
                loginError: '',
                advanced: true,
                changed: false,
                qtyChanged: false,
                allchanged: false,
                itemsChanged: false,
                shippingChanged: false,
                overrideShipping: false,
                keepPricing: false,
                quotes: [],
                quote: false,
                saved: false,
                shipState: false,
                search: '',
                page: 1,
                pageSize: 50,
                count: 0,
                pages: 1,
                modalView: '',
                addressType: '',
                editingAddress: false,
                editingDetails: false,
                editingInfo: false,
                statuses: Quotes.STATUSES,
                concessionToggles: Quotes.CONCESSION_TOGGLES,
                activeFilter: false,
                sortBy: '',
                sortDir: 'asc',
                filterOp: '',
                productFilter: '',
                products: [],
                shareNote: '',
                shareEmail: '',
                checkoutEmail: '',
                noteText: '',
                settings: { ca_tax: 7.25 },
                rates:[],
                editingRate: {},
                editingRateName: '',
                ratesLoading: false,
                shippingError: '',
                pendingTax: null,
                taxRequestId: 0,
                insertIndex: -1,
                noRates: false,
                accessories: [],
                filters: [
                    { name: 'Excluded', field: 'detail.is_excluded', value: 'Yes', value2: '', op: 'equals', applied: false, bool: true, type: '' },
                    { name: 'Quote Number', field: 'number', value: '', value2: '', op: 'equals', applied:false, bool: false, type: ''  },
                    { name: 'Status', field: 'status', value: '', value2: '', op: 'equals', applied:false, bool: false, type: '', options: Quotes.STATUSES  },
                    { name: 'Visible', field: 'is_visible', value: '', value2: '', op: 'equals', applied:false, bool: true, type: '' },
                    { name: 'Expired', field: 'is_expired', value: '', value2: '', op: 'equals', applied:false, bool: true, type: '' },
                    { name: 'Created Date', field: 'created_at', value: '', value2: '', op: 'equals', applied:false, bool: false, type: 'date' },
                    { name: 'Generated By', field: 'generated_by', value: '', value2: '', op: 'equals', applied:false, bool: false, type: ''  },
                    { name: 'Follow Up 1', field: 'detail.follow_up_1', value: '', value2: '', op: 'equals', applied:false, bool: false, type: 'date'  },
                    { name: 'Follow Up 2', field: 'detail.follow_up_2', value: '', value2: '', op: 'equals', applied:false, bool: false, type: 'date'  },
                    { name: 'Completed Date', field: 'completed_at', value: '', value2: '', op: 'equals', applied:false, bool: false, type: 'date'  },
                    { name: 'Total', field: 'total', value: '', value2: '', op: 'equals', applied:false, bool: false, type: ''  },
                    { name: 'Email', field: 'email', value: '', value2: '', op: 'equals', applied:false, bool: false, type: ''  },
                    { name: 'PID', field: 'detail.pid', value: '', value2: '', op: 'equals', applied:false, bool: false, type: ''  },
                    { name: 'Parent PID', field: 'detail.parent_pid', value: '', value2: '', op: 'equals', applied:false, bool: false, type: ''  },
                    { name: 'Is Internal', field: 'detail.is_internal', value: 'Internal', value2: '', op: 'equals', applied:false, bool: true, options: ['Internal', 'External'], type: ''  },
                    { name: 'Has Note', field: 'has_note', value: 'Yes', value2: '', op: 'equals', applied:false, bool: true, type: ''  },
                ],
                shippingMethods: [
                    'In-Store Pickup - 1556 Woodland Drive Saline, MI 48176',
                    'Freight',
                    'US Postal Service - Priority Mail',
                    'UPS - UPS® Ground',
                    'UPS - UPS 3 Day Select®',
                    'US Postal Service - Priority Mail Express',
                    'UPS - UPS 2nd Day Air®',
                    'UPS - UPS 2nd Day Air A.M.®',
                    'UPS - UPS Next Day Air Saver®',
                    'UPS - UPS Next Day Air®',
                    'UPS - UPS Next Day Air® Early',
                    'UPS Ground Freight - UPS Ground with Freight Pricing',
                    'US Postal Service - Priority Mail International',
                    'UPS - UPS® Standard',
                    'US Postal Service - Priority Mail Express International',
                    'UPS - UPS Worldwide Expedited®',
                    'UPS - UPS Worldwide Saver®',
                    'UPS - UPS Worldwide Express®',
                    'UPS LTL Freight® - TForce Freight LTL',
                    'Ex Works - 1556 Woodland Drive Saline, MI 48176',
                    'UPS - UPS Collect'
                ],
                selectedStates: [],
                interests: [
                    { label: 'Physics', value: 'P' },
                    { label: 'Physical Science', value: 'PS' },
                    { label: 'Chemistry', value: 'C' },
                    { label: 'Earth and Space Science', value: 'ESS' },
                    { label: 'STEM', value: 'STEM' },
                    { label: 'Environmental Science', value: 'ENV' },
                    { label: 'Astronomy', value: 'ASTRO' },
                    { label: 'Math', value: 'M' },
                    { label: 'Other', value: 'O' }
                ],
                isChecked: {},
                roleDetailTextInput: '',
                roleDetailCheckboxInput: ''
            }
        },
        computed: {
            selectedInterests() {
                return selectedValues = this.interests.map((interest, index) => {
                    return this.isChecked[interest.value] ? interest.value + (index === this.interests.length - 1 ? '' : '/') : '/';
                }).join('');
            }
        },
        methods: {
            cleanName(name) {
                return name.replaceAll(/&amp;/g, '&').replaceAll(/&#39;/g, "'");
            },
            authenticate() {
                Quotes.authenticate(this.quoteEmail, this.quotePass);
            },
            showNewVersion() {
                Quotes.getPricingChanges(this.quote);
            },
            formatPhone(str) {
                let cleaned = ('' + str).replace(/\D/g, '');

                //Check if the input is of correct length
                let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

                if (match) {
                  return match[1] + '-' + match[2] + '-' + match[3];
                }

                return str;
            },
            share() {
				if(this.shareEmail) {
					Quotes.share(this.quote, this.shareEmail, this.shareNote);
				}
                this.closeModal();
			},
            checkout() {
				Quotes.checkout(this.quote);
			},
            sendCheckout() {
				if(this.checkoutEmail) {
					Quotes.sendCheckout(this.quote, this.checkoutEmail);
				}
                this.closeModal();
			},
			shareQuote() {
				this.shareEmail = '';
				this.modalView = 'share';
			},
            shareCheckout() {
				this.checkoutEmail = '';
				this.modalView = 'send-checkout';
			},
            searchUpdated(e) {
                if(e.key == 'Enter')
                    Quotes.getQuotes();
            },
            searchProducts() {
                Quotes.getProducts(this.productFilter);
            },
            addProduct(product) {
                let price = product.variants.length > 0 ? parseFloat(product.variants[0].price) : 0;
                let item = {
                    name: product.title,
                    price: price,
                    original_price: price * 100,
                    discounted_price: price * 100,
                    sku: product.sku,
                    product_id: product.shopify_product_id,
                    variant_id: product.variants.length > 0 ? product.variants[0].shopify_variant_id : '',
                    quote_id: this.quote.id,
                    quantity: product.quantity ? product.quantity : 1,
                    product: product
                };
                this.updatePricing(item);
                this.quote.items.splice(this.insertIndex+1, 0, item);

                this.products = [];
                this.productFilter = '';
            },
            getDiscounts() {
                Quotes.getDiscounts();
                this.qtyChanged = false;
            },
            viewQuote(q) {
                Quotes.normalizeQuote(q);
                this.quote = q;
                this.changed = false;
                this.shippingChanged = false;
                for(var i = 0; i < this.quote.items.length; i++) {
                    this.quote.items[i].price /= 100;
                    this.quote.items[i].price = (Math.round(100*this.quote.items[i].price)/100).toFixed(2);
                    this.updateDiscounts(this.quote.items[i]);
                }

                this.getSubtotal(this.quote);
                this.getTotal(this.quote);

                this.saved = clone(q);
                this.shipState = clone(q);
                setTimeout(function() {
                    Quotes.initialized = true;
                }, 500);

                $('body').addClass('no-scroll');
            },
            closeQuote() {
                $('body').removeClass('no-scroll');
                this.quote = false;
                Quotes.initialized = false;
                this.itemsChanged = false;
                this.keepPricing = false;

                Quotes.getQuotes();
            },
            getSubtotal(q) {
                let subtotal = 0;
                for(var i = 0; i < this.quote.items.length; i++) {
                    let item = this.quote.items[i];
                    subtotal += parseFloat(item.price) * item.quantity;
                }

                this.quote.subtotal = subtotal * 100;
                return this.quote.subtotal;
            },
            getTaxable(q) {
                console.log('getaxable2');
                let taxable = 0;
                for(var i = 0; i < this.quote.items.length; i++) {
                    let item = this.quote.items[i];
                    if(item.product && item.product.is_taxable)
                    taxable += parseFloat(item.price) * item.quantity;
                }
                console.log('taxable', taxable);

                return taxable*100;
            },
            getTotal(q) {
                this.getSubtotal();

                let total = this.quote.subtotal + this.quote.tax;
                if(!this.shippingChanged) {
                    total += this.quote.ship_amount*100;
                }

                this.quote.total = Math.round(total);

                Quotes.checkChanged();
                return this.quote.total;
            },
            removeItem(i) {
                this.quote.items.splice(i, 1);
                Quotes.checkChanged();
            },
            editBilling(address) {
                this.addressType = 'Billing';
                this.modalView = 'edit-address';
                this.editingAddress = clone(address);
                setTimeout(function() {
					Quotes.checkAddressState();
				},1);
            },
            editShipping(address) {
                this.addressType = 'Shipping';
                this.modalView = 'edit-address';
                this.editingAddress = clone(address);
                setTimeout(function() {
					Quotes.checkAddressState();
				},1);
            },
            editDetails() {
                this.modalView = 'edit-details';
                this.editingDetails = clone(this.quote.detail);
                this.editingDetails.order_name = this.quote.order_name;
            },
            canEditProgress() {
                return this.role === 'admin' || this.role === 'editor';
            },
            isStatusLocked(status) {
                return status === Quotes.COMPLETED_STATUS;
            },
            progressChanged() {
                Quotes.checkChanged();
            },
            discountChanged() {
                this.quote.detail.overall_discount = Quotes.cleanDiscount(this.quote.detail.overall_discount);
                Quotes.checkChanged();
            },
            isDiscountValid() {
                return !this.quote || Quotes.isValidDiscount(this.quote.detail.overall_discount);
            },
            editInfo() {
                this.editingInfo = {
                    email: this.quote.email,
                    role: this.quote.role,
                    role_detail: this.quote.role_detail,
                    timeframe: this.quote.timeframe,
                    exp_date: this.quote.exp_date,
                    is_expired: this.quote.is_expired ? "1" : "0",
                    tax_exempt: this.quote.tax_exempt ? "1" : "0",
                    is_visible: this.quote.is_visible ? "1" : "0",
                    silence_notifications: this.quote.silence_notifications ? "1" : "0",
                }

                this.isChecked = {};

                if (this.quote.role === 'Purchasing/Administrative' && this.quote.role_detail) {
                    this.roleDetailTextInput = this.editingInfo.role_detail;
                }

                const roleDetailArray = this?.quote?.role_detail?.split('/');
                if (roleDetailArray) {
                    roleDetailArray.forEach((el) => {
                        this.isChecked[el] = true;
                    })
                }

                this.modalView = 'edit-info';

            },
            roleChanged() {
                if (['Teacher/Professor', 'Lab Supervisor', 'Homeschool'].indexOf(this.editingInfo.role) >= 0) {
                    this.editingInfo.role_detail = this.roleDetailCheckboxInput;
                } else {
                    this.editingInfo.role_detail = this.roleDetailTextInput;
                }

                if (['Teacher/Professor', 'Lab Supervisor'].indexOf(this.editingInfo.role) >= 0) {
                    this.updateHiddenInput();
                }
            },
            changeRoleInput() {
                if (['Teacher/Professor', 'Lab Supervisor', 'Homeschool'].indexOf(this.editingInfo.role) >= 0) {
                    this.roleDetailCheckboxInput = this.editingInfo.role_detail;
                } else {
                    this.roleDetailTextInput = this.editingInfo.role_detail;
                }

                if (['Teacher/Professor', 'Lab Supervisor'].indexOf(this.editingInfo.role) >= 0) {
                    this.updateHiddenInput();
                }
            },
            removeExtraKeys(obj1, obj2) {
                for (let key in obj1) {
                    if (!obj2.hasOwnProperty(value)) {
                        delete obj1[key];
                    }
                }
                return obj1;
            },
            updateHiddenInput() {
                this.isChecked = Object.keys(this.isChecked)
                    .filter(key => this.interests.some(item => item.value === key))
                    .reduce((acc, key) => {
                        acc[key] = this.isChecked[key];
                        return acc;
                    }, {});

                const selectedValues = this.interests.map((interest, index) => {
                    return this.isChecked[interest.value] ? interest.value + (index === this.interests.length - 1 ? '' : '/') : '/';
                }).join('');

                this.roleDetailCheckboxInput = selectedValues;
                this.editingInfo.role_detail = selectedValues;
            },
            canSaveAddress(address) {
                return address.first_name &&
                    address.last_name &&
                    address.address &&
                    address.city &&
                    (address.state || this.selectedStates.length == 0) &&
                    address.country &&
                    address.phone &&
                    (address.zip || address.country != 'United States');
            },
            // Human-readable reason the Checkout button is disabled (mirrors its :disabled binding),
            // so a disabled Checkout explains itself instead of doing nothing silently. '' = enabled.
            checkoutBlockReason() {
                const q = this.quote;
                if (!q) return '';
                if (q.is_expired) return 'This quote is expired — create a new version to check out.';
                if (q.completed_at) return 'This quote is already completed.';
                if (this.changed || this.allchanged) return 'Save your changes before checking out.';
                if (!this.canSaveAddress(q.billing)) return 'Add a complete billing address before checking out.';
                if (!this.canSaveAddress(q.shipping)) return 'Add a complete shipping address before checking out.';
                return '';
            },
            saveAddress() {
                if(this.addressType == 'Billing')
                    this.quote.billing = clone(this.editingAddress);
                else if(this.addressType == 'Shipping')
                    this.quote.shipping = clone(this.editingAddress);

                Quotes.checkChanged();
                this.closeModal();
            },
            saveDetails() {
                if(this.canSaveDetails()) {
                    this.quote.detail = clone(this.editingDetails);
                    this.quote.order_name = this.editingDetails.order_name;

                    Quotes.checkChanged();
                    this.closeModal();
                }
            },
            canSaveDetails() {
                let valid = (this.editingDetails.manual_date && this.editingDetails.manual_amount) ||
                    (!this.editingDetails.manual_date && !this.editingDetails.manual_amount);

                return valid;
            },
            newQuote() {
                let vm = this;
                vm.noRates = false;
                $.post(Quote.endpoint + 'quotes', function(response) {
                    vm.viewQuote(response.quote);
                });
            },
            saveQuote() {
                if(this.ratesLoading || !this.isDiscountValid()) return;
                Quotes.saveQuote(this.quote);
            },
            saveInfo() {
                this.quote.email = this.editingInfo.email;
                this.quote.role = this.editingInfo.role;
                this.quote.role_detail = this.editingInfo.role_detail;
                this.quote.timeframe = this.editingInfo.timeframe;
                this.quote.exp_date = this.editingInfo.exp_date;
                this.quote.is_expired = this.editingInfo.is_expired == 1 ? 1 : 0;
                this.quote.tax_exempt = this.editingInfo.tax_exempt == 1 ? 1 : 0;
                this.quote.is_visible = this.editingInfo.is_visible == 1 ? 1 : 0;
                this.quote.silence_notifications = this.editingInfo.silence_notifications == 1 ? 1 : 0;

                Quotes.checkChanged();
                this.closeModal();
            },
            pageSizeChanged() {
                Quotes.getQuotes();
            },
            noteChanged(e) {
                if(e.keyCode == 13 && this.noteText) {
                    Quotes.addNote(this.quote, this.noteText);
                    this.noteText = '';
                }
            },
            searchChanged(e) {
                if(e.keyCode == 13 && this.search) {
                    Quotes.getQuotes();
                }
            },
            showList(){
                Quotes.getQuotes();
            },
            discard() {
                this.quote = clone(this.saved);
                this.qtyChanged = false;
                this.changed = false;
            },
            saveExcluded(quote, excluded) {
                Quotes.saveExcluded(quote, excluded);
            },
            createVersion() {
                if(this.ratesLoading || !this.isDiscountValid()) return;
                Quotes.createVersion(this.quote);
                this.qtyChanged = false;
            },
            editQuoteAddress() {
                Quotes.editQuoteAddress(this.quote);
            },
            closeModal() {
                if(this.modalView == 'shipping-rates') {
                    this.taxRequestId++;
                    this.pendingTax = null;
                    this.ratesLoading = false;
                }
                this.modalView = '';
            },
            prevPage() {
                if(this.page > 1) {
                    this.page--;
                    Quotes.getQuotes();
                }
            },
            nextPage() {
                if(this.page < this.pages) {
                    this.page++;
                    Quotes.getQuotes();
                }
            },
            setSort(field) {
                this.sortDir = (field == this.sortBy) ? (this.sortDir == 'desc' ? 'asc' : 'desc') : 'asc';
                this.sortBy = field;
                this.page = 1;
                Quotes.getQuotes();
            },
            addAccessoriesToQuote() {
				for(var i = 0; i < this.accessories.length; i++) {
					let acc = this.accessories[i];
					if(acc.quantity > 0) {
						this.addProduct(acc);
					}
				}

                this.closeModal();
			},
			decAcc(acc) {
				acc.quantity -= 1;
				this.$forceUpdate();
			},
			incAcc(acc) {
				acc.quantity += 1;
				this.$forceUpdate();
			},
            getAccessories(item, i) {
                let vm = this;
                vm.insertIndex = i;
                $.get(Quote.endpoint + 'accessories', { product : item.product.id }, function(response) {
                    vm.accessories = response.accessories;
                    vm.accessories.map(a => a.quantity = 0);
                    vm.modalView = 'add-accessories'
                });
            },
            clearFilter() {
                this.page = 1;
                for(var i = 0; i < this.filters.length; i++) {
                    if(this.filters[i].field == this.activeFilter.field) {
                        this.filters[i] = clone(this.activeFilter);
                        this.filters[i].applied = false;
                        Quotes.getQuotes();
                    }
                }

                this.closeModal();
            },
            getQuotes() {
                Quotes.getQuotes();
            },
            productInItems(product) {
                let exists = false;
                let variantId = product.variants.length > 0 ? product.variants[0].shopify_variant_id : null;
                this.quote.items.map(m => {
                    if(m.product.id == product.id && m.product.tags.indexOf('custom') < 0) {
                        if (variantId && m.variant_id) {
                            if (m.variant_id == variantId) exists = true;
                        } else {
                            exists = true;
                        }
                    }
                });
                return exists;
            },
            clearFilters() {
                for(var i = 0; i < this.filters.length; i++) {
                    this.filters[i].applied = false;
                }

                this.search = '';
                Quotes.getQuotes();
            },
            clearFilter() {
                for(var i = 0; i < this.filters.length; i++) {
                    if(this.filters[i].field == this.activeFilter.field) {
                        this.filters[i].applied = false;
                        Quotes.getQuotes();
                        break;
                    }
                }
                this.closeModal();
            },
            applyFilter() {
                this.page = 1;
                for(var i = 0; i < this.filters.length; i++) {
                    if(this.filters[i].field == this.activeFilter.field) {
                        this.filters[i] = clone(this.activeFilter);
                        this.filters[i].applied = true;
                        Quotes.getQuotes();
                        break;
                    }
                }
                this.closeModal();
            },
            filterApplied(field) {
                let applied = false;
                this.filters.map(f => {
                    if(f.field == field) {
                        applied = f.applied;
                    }
                });

                return applied;
            },
            shipNameChanged() {
                this.shipState = clone(this.quote);
            },
            calcShipping(selectedMethod = null) {
                let vm = this;
                // Block repeated user clicks on "calculate" while a request is in flight.
                // The internal changeRate() call passes a selectedMethod and is allowed through.
                if (selectedMethod === null && vm.ratesLoading) return;
                vm.ratesLoading = true;
                vm.shippingError = '';
                vm.noRates = false;
                vm.ship_name = '';
                let items = [];
                let customOnly = true;

                vm.quote.items.map(i => {
                    if(i.product && !i.product.is_digital && i.variant_id) {
                        const itemObject = {
                            variantId: i.variant_id,
                            quantity: parseInt(i.quantity),
                            priceOverride: {
                                amount: Number(i.price),
                                currencyCode: "USD"
                            }
                        }

                        items.push(itemObject);
                    } else if (i.product) {
                        const itemObject = {
                            sku: i.product.sku,
                            title: i.product.title,
                            originalUnitPrice: i.product.original_line_price,
                            quantity: parseInt(i.product.quantity),
                            requiresShipping: i.product.requires_shipping,
                            priceOverride: {
                                amount: Number(i.price),
                                currencyCode: "USD"
                            }
                        }

                        items.push(itemObject);
                    }

                    if (i.product.tags.indexOf('custom') < 0) {
                        customOnly = false;
                    }
                });

                if(items.length == 0) {
                    vm.ratesLoading = false;
                    vm.rates = [];
                    vm.shipAmount = 0;
                    this.quote.ship_name = '';
                    this.quote.ship_code = 'No Shipping';
                    this.quote.ship_amount = 0;
                    this.shipState = clone(this.quote);
                    return;
                }

                if (selectedMethod !== null && selectedMethod && selectedMethod.title) {
                    const requestId = ++vm.taxRequestId;
                    vm.pendingTax = null;

                    const processTax = async () => {
                        const countryCode = await getCountryCodeByName(vm.quote.shipping.country);

                        const params = {
                            lineItems: items,
                            taxExempt: vm.quote.tax_exempt === 1 ? true : false,
                            shippingAddress: {
                                firstName: vm.quote.shipping.first_name,
                                lastName: vm.quote.shipping.last_name,
                                address1: vm.quote.shipping.address,
                                city: vm.quote.shipping.city,
                                provinceCode: getProvinceCode(vm.quote.shipping.state),
                                countryCode: countryCode,
                                zip: vm.quote.shipping.zip,
                                phone: vm.quote.shipping.phone
                            },
                            shippingLine: selectedMethod
                        };

                        fetch(Quote.endpoint + 'quote/calculate', {
                            method: "POST",
                            headers: {
                                "Accept": "application/json",
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(params)
                        })
                        .then(response => {
                            if (!response.ok) throw new Error('quote/calculate failed: ' + response.status);
                            return response.json();
                        })
                        .then(response => {
                            if (requestId !== vm.taxRequestId) return; // superseded or cancelled
                            vm.ratesLoading = false;
                            if (response.totalTaxSet) {
                                vm.pendingTax = Math.round(parseFloat(response.totalTaxSet.presentmentMoney.amount) * 100);
                            }
                        })
                        .catch(error => {
                            if (requestId !== vm.taxRequestId) return;
                            console.error('quote/calculate tax error: ' + error);
                            vm.ratesLoading = false;
                            vm.shippingError = 'Could not calculate tax. Please try again.';
                        });
                    };

                    processTax().catch(error => {
                        if (requestId !== vm.taxRequestId) return;
                        console.error('quote/calculate tax error: ' + error);
                        vm.ratesLoading = false;
                        vm.shippingError = 'Could not calculate tax. Please try again.';
                    });
                } else {
                    // Don't compute rates with an incomplete address: storefront returns 422,
                    // and the middleware can't price an unknown destination either.
                    const ship = vm.quote.shipping || {};
                    if (!ship.zip || !ship.state || !ship.country) {
                        vm.ratesLoading = false;
                        vm.shippingError = 'Enter a complete shipping address (street, city, state and ZIP) before calculating.';
                        return;
                    }

                    // Shared: push rates into the UI / open the rate picker (used by both variants).
                    const applyRates = (rates) => {
                        vm.rates = rates;
                        if (vm.rates.length > 0) {
                            vm.editingRate = vm.rates[0];
                            vm.editingRateName = vm.rates[0].name;
                            vm.modalView = 'shipping-rates';
                            vm.$nextTick(() => {
                                if(vm.editingRateName) {
                                    vm.changeRate();
                                }
                            });
                        } else {
                            vm.noRates = true;
                            vm.overrideShipping = true;
                        }
                    };

                    const onError = (e) => {
                        if (e && e.code === 'THROTTLED') {
                            vm.shippingError = 'Shopify is temporarily rate-limiting shipping calculation'
                                + (e.retryAfter ? ' (try again in ~' + e.retryAfter + 's)' : '')
                                + '. Please try again shortly.';
                        } else {
                            vm.shippingError = 'Could not calculate shipping. Please try again.';
                        }
                    };

                    if (mwRatesEnabled()) {
                        // Variant ?mv=1 — rates from the middleware; no storefront cart calls, so no 429/503.
                        const runMw = async () => {
                            try {
                                const countryCode = await getCountryCodeByName(vm.quote.shipping.country);
                                const params = {
                                    lineItems: items,
                                    taxExempt: vm.quote.tax_exempt === 1 ? true : false,
                                    shippingAddress: {
                                        firstName: vm.quote.shipping.first_name,
                                        lastName: vm.quote.shipping.last_name,
                                        address1: vm.quote.shipping.address,
                                        city: vm.quote.shipping.city,
                                        provinceCode: getProvinceCode(vm.quote.shipping.state),
                                        countryCode: countryCode,
                                        zip: vm.quote.shipping.zip,
                                        phone: vm.quote.shipping.phone
                                    }
                                };

                                const res = await cartApi(Quote.endpoint + 'quote/calculate', { method: 'POST', body: params });
                                const rates = (res.availableShippingRates || []).map(r => {
                                    let name = r.title || '';
                                    const idx = name.indexOf('(');
                                    if (idx > 0) name = name.substring(0, idx).trim();
                                    return {
                                        name: name,
                                        code: r.title,
                                        price: r.price ? parseFloat(r.price.amount).toFixed(2) : '0.00',
                                        currency: r.price ? r.price.currencyCode : 'USD',
                                        handle: r.handle
                                    };
                                });
                                applyRates(rates);
                            } catch (e) {
                                onError(e);
                            } finally {
                                vm.ratesLoading = false;
                            }
                        };

                        runMw();
                        return;
                    }

                    // Default variant — rates from the storefront cart (/cart/*.js).
                    let cartItems = [];
                    vm.quote.items.map(i => {
                        if(i.product && !i.product.is_digital && i.variant_id) {
                            cartItems.push({
                                id: i.variant_id,
                                quantity: parseInt(i.quantity)
                            });
                        }
                    });

                    if(cartItems.length == 0) {
                        vm.noRates = true;
                        vm.overrideShipping = true;
                        vm.ratesLoading = false;
                        return;
                    }

                    const run = async () => {
                        try {
                            await cartApi('/cart/clear.js', { method: 'POST' });
                            await cartApi('/cart/add.js', { method: 'POST', body: { items: cartItems } });

                            const rates = await Quotes.getShippingRates(vm.quote.shipping);

                            const mapped = [];
                            for (var i = 0; i < rates.length; i++) {
                                let rate = rates[i];
                                let idx = rate.name.indexOf('(');
                                if(idx > 0)
                                    rate.name = rate.name.substring(0, idx).trim();

                                mapped.push(rate);
                            }
                            applyRates(mapped);

                            // Best-effort cleanup; ignore failures.
                            cartApi('/cart/clear.js', { method: 'POST' }).catch(() => {});
                        } catch (e) {
                            onError(e);
                        } finally {
                            vm.ratesLoading = false;
                        }
                    };

                    run();
                }
            },
            incrementQty(item) {
                item.quantity++;
                this.updatePricing(item);
            },
            decrementQty(item) {
                if(item.quantity <= 1)
                    return;

                item.quantity--;
                this.updatePricing(item);
            },
            discountQty(item) {
                if(!item.product) return;
                let qty = '';
                item.product.metafields.map(m => {
                    if(m.key == 'QTYpricingQTYtier1')
                        qty = parseInt(m.value);
                });

                return qty;
            },
            keepChanged() {
                this.quote.items.map((item) => {
                    this.updatePricing(item);
                });
            },
            updateDiscounts(item) {
                if(!item.product) return;
                item.discountQty = 0;
				item.discountPrice = 0;
				item.discountQty2 = 0;
				item.discountPrice2 = 0;

                item.product.metafields.map(m => {

                    if(m.key == 'QTYpricingQTYtier1')
                        item.discountQty = parseInt(m.value);

                    if(m.key == 'QTYpricingAMTtier1')
                        item.discountPrice = parseFloat(m.value) * 100;

                    if(m.key == 'QTYpricingQTYtier2')
                        item.discountQty2 = parseInt(m.value);

                    if(m.key == 'QTYpricingAMTtier2')
                        item.discountPrice2 = parseFloat(m.value) * 100;
                });
            },
            updatePricing(item) {

                if(quotesCheckoutApp.keepPricing)
                    return;

                if(!Quotes.initialized || !(Quotes.checkItemsChanged() || this.shippingChanged))
                    return;

                item.discountQty = 0;
				item.discountPrice = 0;
				item.discountQty2 = 0;
				item.discountPrice2 = 0;

                item.product.metafields.map(m => {

                    if(m.key == 'QTYpricingQTYtier1')
                        item.discountQty = parseInt(m.value);

                    if(m.key == 'QTYpricingAMTtier1')
                        item.discountPrice = parseFloat(m.value) * 100;

                    if(m.key == 'QTYpricingQTYtier2')
                        item.discountQty2 = parseInt(m.value);

                    if(m.key == 'QTYpricingAMTtier2')
                        item.discountPrice2 = parseFloat(m.value) * 100;
                });

                item.price = item.original_price / 100;
                if(item.discountQty > 0 && item.quantity >= item.discountQty)
                {
                    item.price = item.discountPrice / 100;
                    item.discounted_price = item.price*100;
                }

                if(item.discountQty2 > 0 && item.quantity >= item.discountQty2)
                {
                    item.price = item.discountPrice2 / 100;
                    item.discounted_price = item.price*100;
                }

                quotesCheckoutApp.$forceUpdate();
            },
            changeRate() {
                if(this.editingRateName) {
                    for(var i = 0; i < this.rates.length; i++) {
                        if(this.rates[i].name == this.editingRateName) {
                            this.calcShipping({
                                title: this.rates[i].name,
                                priceWithCurrency: {
                                    amount: this.rates[i].price,
                                    currencyCode: this.rates[i].currency
                                }
                            });
                            return;
                        }
                    }
                }
            },
            selectRate() {
                if(this.ratesLoading) return;
                if(this.pendingTax === null) {
                    this.changeRate();
                    return;
                }

                if(this.editingRateName) {
                    for(var i = 0; i < this.rates.length; i++) {
                        if(this.rates[i].name == this.editingRateName) {
                            this.editingRate = this.rates[i];
                            this.quote.ship_name = this.editingRate.name;
                            this.quote.ship_code = this.editingRate.code;
                            this.quote.ship_amount = parseFloat(this.editingRate.price).toFixed(2);
                            this.quote.tax = this.pendingTax;
                            this.shipState = clone(this.quote);
                            this.closeModal();

                            cartApi('/cart/clear.js', { method: 'POST' }).catch(() => {});
                            return;
                        }
                    }
                }
            },
            showFilter(field) {
                let filter = false;
                this.filters.map(f => {
                    if(f.field == field)
                        filter = f;
                });

                if(filter) {
                    this.activeFilter = clone(filter);
                    this.modalView = 'edit-filter';
                }
            },
            formatDate(d) {
                if(!d) return '';

                let parts = d.substring(0, 10).split('-');
				return  parts[1] + '/' + parts[2] + '/' + parts[0];
                return d.substring(0, 10);
            },
            formatDateTime(d) {
                var day = dayjs(d);
				var now = dayjs();
				if(day.format('YYYY-MM-DD') == now.format('YYYY-MM-DD'))
					return day.format('[Today at] h:mma');

				return day.format('MM/DD/YYYY h:mma');
            },
            formatMoney(p) {
                return priceFormatter.format(p/100);
            },
            isCustomItem(item) {
                console.log('is custom', item);
                if(!item.product || !item.product.tags) return true;
                return item.product.tags.indexOf('custom') >= 0;
            },
            shippingUpdated() {
                Quotes.checkChanged();
            }
        }
    });

    Quotes.authenticate = function(email, pass) {
        $.get(Quotes.endpoint + 'auth', { email: email, password: pass}, function(response) {
            if(response.role) {
                Cookies.set('quoterole', response.role);
                window.location.reload();
            }
            else {
                quotesCheckoutApp.loginError = 'Invalid login';
            }
        });
    }

    Quotes.checkAddressState = function() {
        let stateList = [];

		let provinces = $('#address-country option:selected').attr('data-provinces');
		if(provinces) {
			let states = JSON.parse(provinces);
			states.map(s => {
				stateList.push(s[0]);
			});
		}

        quotesCheckoutApp.selectedStates = stateList;
    }

    Quotes.getQuotes = function() {

        let applied = quotesCheckoutApp.filters.filter(f => f.applied);

        const params = {
            page: quotesCheckoutApp.page,
            pagesize: quotesCheckoutApp.pageSize,
            search: quotesCheckoutApp.search,
            sortBy: quotesCheckoutApp.sortBy,
            sortDir: quotesCheckoutApp.sortDir,
            filters: applied
        };

        $.get(Quote.endpoint + 'quotes', params, function(response) {
            quotesCheckoutApp.quotes = response.quotes;
            quotesCheckoutApp.settings = response.settings;
            quotesCheckoutApp.quote = false;
            quotesCheckoutApp.count = response.count;
            quotesCheckoutApp.pages = Math.floor((response.count + 1) / quotesCheckoutApp.pageSize) + 1;
        });
    }


	Quotes.getPricingChanges = function(quote, callback) {
        if(quotesCheckoutApp.keepPricing)  {
            if(callback) callback();
            return;
        }

		let ctx = this;
		$.get(Quotes.endpoint + 'quotes/' + quote.guid + '/prices', function(response) {

            for(var i = 0; i < response.quote.items.length; i++) {
                for(var j = 0; j < quotesCheckoutApp.quote.items.length; j++) {
                    if(response.quote.items[i].sku == quotesCheckoutApp.quote.items[j].sku) {
                        quotesCheckoutApp.quote.items[j].expired_price = response.quote.items[i].expired_price;
                        quotesCheckoutApp.quote.items[j].original_price = response.quote.items[i].original_price;
                    }
                }
            }

			for(var i = 0; i < quotesCheckoutApp.quote.items.length; i++) {
				quotesCheckoutApp.updatePricing(quotesCheckoutApp.quote.items[i]);
			}

            if(callback) callback();
        });
	}

    Quotes.saveQuote = function(quote) {

        quote.detail.overall_discount = Quotes.cleanDiscount(quote.detail.overall_discount);

        const params = {
            quote: quote
        };

        $.post(Quote.endpoint + 'quotes/' + quote.guid, params, function(response) {
            Quotes.syncSavedProgress(quote, response);
            quotesCheckoutApp.saved = clone(quotesCheckoutApp.quote);
            quotesCheckoutApp.shipState = clone(quotesCheckoutApp.quote);
            Quotes.checkChanged();
        });
    }

    // Backend auto-silences Closed – Lost quotes, so pick up what it stored for the posted quote.
    Quotes.syncSavedProgress = function(quote, response) {
        const stored = response && response.quote;
        if(!stored || stored.guid !== quote.guid) return;

        if(stored.status) quote.status = stored.status;
        if('silence_notifications' in stored) quote.silence_notifications = stored.silence_notifications ? 1 : 0;
    }

    Quotes.createVersion = function(quote) {

        quote.detail.is_internal = true;

        const params = {
            quote: quote
        };

        Quotes.getPricingChanges(quotesCheckoutApp.quote, function() {
            quotesCheckoutApp.getTotal();
            $.post(Quote.endpoint + 'quotes/' + quote.guid + '/version', params, function(response) {
                let expired = quote.is_expired;
                quotesCheckoutApp.quote.id = response.quote.id;
                quotesCheckoutApp.quote.guid = response.quote.guid;
                quotesCheckoutApp.quote.name = response.quote.name;
                quotesCheckoutApp.quote.is_expired = response.quote.is_expired;
                quotesCheckoutApp.quote.exp_date = response.quote.exp_date;
                // The new version is not completed, so the Status dropdown unlocks without a reload
                quotesCheckoutApp.quote.completed_at = response.quote.completed_at || null;
                Quotes.syncSavedProgress(quote, response);
                quotesCheckoutApp.saved = clone(quotesCheckoutApp.quote);
                quotesCheckoutApp.shipState = clone(quotesCheckoutApp.quote);

                if(expired) {
                    // quotesCheckoutApp.quote.ship_name = '';
                    // quotesCheckoutApp.quote.ship_amount = '';
                }

                Quotes.checkChanged();
            });
        });
    }

    Quotes.editQuoteAddress = function(quote) {
        $.post(Quotes.endpoint + 'quotes/' + quote.guid + '/checkout', function(response) {
            if (response?.url) {
                window.location = response.url;
            }
        });
    }

    Quotes.checkout = function(quote) {
		quotesCheckoutApp.checkingOut = true;
		 $.post(Quotes.endpoint + 'quotes/' + quote.guid + '/checkout', function(response) {
            window.open(response.url, '_blank');
		 });
	}

    Quotes.saveExcluded = function(quote, excluded) {

        const params = {
            excluded: excluded ? true : ''
        };

        $.post(Quote.endpoint + 'quotes/' + quote.guid + '/excluded', params, function(response) {
            quote.detail.is_excluded = excluded;
        });
    }

    Quotes.init = function() {
        Quotes.getQuotes();

		$('body').on('change', '#address-country', function() {
            quotesCheckoutApp.editingAddress.state = '';
            Quotes.checkAddressState();
        });
    }

    Quotes.getParams = function(quote) {
        let params = clone({
            email: quote.email,
            billing: quote.billing,
            shipping: quote.shipping,
            items: quote.items,
            expires: quote.expires_at,
            shipAmount: quote.ship_amount,
            shipName: quote.ship_name
        });

        return params;
    }

    Quotes.getShipParams = function(quote) {
        let params = clone({
            city: quote.shipping ? quote.shipping.city : '',
            state: quote.shipping ? quote.shipping.state : '',
            zip: quote.shipping ? quote.shipping.zip : '',
            items: quote.items
        });

        return params;
    }

    Quotes.getAllParams = function(quote) {
        let params = clone({
            email: quote.email,
            billing: quote.billing,
            shipping: quote.shipping,
            items: quote.items,
            expires: quote.expires_at,
            shipAmount: quote.ship_amount,
            detail: quote.detail,
            role: quote.role,
            role_detail: quote.role_detail,
            status: quote.status,
            timeframe: quote.timeframe,
            exp_date: quote.exp_date,
            expired: quote.is_expired,
            tax_exempt: quote.tax_exempt,
            is_visible: quote.is_visible,
            silence_notifications: quote.silence_notifications,
            order_name: quote.order_name,
            instructions: quote.instructions
        });

        return params;
    }

    Quotes.checkItemsChanged = function() {
        if(!quotesCheckoutApp.saved)
            return false;

        return checkChanged(
            quotesCheckoutApp.saved.items,
            quotesCheckoutApp.quote.items
        );
    }

    Quotes.initialized = false;

    Quotes.checkChanged = function() {

        quotesCheckoutApp.changed = checkChanged(
            Quotes.getParams(quotesCheckoutApp.saved),
            Quotes.getParams(quotesCheckoutApp.quote)
        );

        quotesCheckoutApp.shippingChanged = checkChanged(
            Quotes.getShipParams(quotesCheckoutApp.shipState),
            Quotes.getShipParams(quotesCheckoutApp.quote)
        );


        if(Quotes.initialized) {
            let itemsChanged = Quotes.checkItemsChanged();
            console.log('kp', quotesCheckoutApp.keepPricing);
            if(!quotesCheckoutApp.keepPricing) {
                if((itemsChanged || quotesCheckoutApp.shippingChanged) && !quotesCheckoutApp.itemsChanged) {
                    Quotes.getPricingChanges(quotesCheckoutApp.quote);
                    quotesCheckoutApp.itemsChanged = true;
                }
            }
        }

        console.log('shipping changed',  quotesCheckoutApp.shippingChanged);

        Quotes.allChanged();
    }

    Quotes.allChanged = function() {
        quotesCheckoutApp.allchanged = checkChanged(
            Quotes.getAllParams(quotesCheckoutApp.saved),
            Quotes.getAllParams(quotesCheckoutApp.quote)
        );
    }

    function debounce(func, timeout = 500){
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
      }

    Quotes.getDiscounts = function() {

        // setTimeout(function() {
        //     fetch('/cart.json')
        //     .then(r => r.json())
        //     .then(cart =>
        //     {
        //         console.log('cart', cart);
        //         for(var i = 0; i < cart.items.length; i++) {
        //             console.log('i', i);
        //             quotesCheckoutApp.quote.items[i].discounted_price = cart.items[i].discounted_price;
        //             quotesCheckoutApp.quote.items[i].price = quotesCheckoutApp.quote.items[i].discounted_price / 100;
        //         }
        //     });
        // }, 1000);

        // return;

        $.post('/cart/clear.js', function() {
            let items = [];
            quotesCheckoutApp.quote.items.map(i => {
                items.push({
                    id: i.variant_id,
                    quantity: i.quantity
                });
            });

            // items.reverse();

            $.post('/cart/add.js', { items: items }, function(r) {
                console.log('r', r);

                let w = window.open("/cart","_blank", "width=1, height=1, top=1, left=1");

                setTimeout(function() {
                    w.close();
                    fetch('/cart.json')
                    .then(r => r.json())
                    .then(cart =>
                    {
                        console.log('cart', cart);
                        for(var i = 0; i < cart.items.length; i++) {
                            console.log('i', i);
                            quotesCheckoutApp.quote.items[i].discounted_price = cart.items[i].discounted_price;
                            if(!quotesCheckoutApp.keepPricing)
                                quotesCheckoutApp.quote.items[i].price = quotesCheckoutApp.quote.items[i].discounted_price / 100;
                        }
                    });
                }, 3000);
            }, 'json');
        })
    }

    Quotes.sendCheckout = function(quote, email) {
        const params = {
            email: email
        };

        $.post(Quotes.endpoint + 'quotes/' + quote.guid + '/checkout', params, function(response) {

        });
   }


   Quotes.getShippingRates = async function(shipping) {
        const params = new URLSearchParams({
            'shipping_address[zip]': shipping.zip || '',
            'shipping_address[country]': shipping.country || '',
            'shipping_address[province]': shipping.state || ''
        });

        const data = await cartApi('/cart/shipping_rates.js?' + params.toString());
        return data.shipping_rates || [];
    }

    Quotes.getProducts = debounce((search) => {
        quotesCheckoutApp.products = [];
        if(search.trim() == '')
            return;

        $.get(Quote.endpoint + 'products?search=' + search, function(response) {
            let flattened = [];
            response.products.forEach(function(product) {
                if (product.variants.length > 1) {
                    product.variants.forEach(function(variant) {
                        let entry = Object.assign({}, product);
                        entry.variants = [variant];
                        entry.sku = variant.sku || product.sku;
                        entry._variant_label = variant.title || variant.option1 || '';
                        flattened.push(entry);
                    });
                } else {
                    product._variant_label = '';
                    flattened.push(product);
                }
            });
            quotesCheckoutApp.products = flattened;
        });
    }, 300);

    Quotes.addNote = function(quote, note) {
        $.post(Quotes.endpoint + 'quotes/' + quote.guid + '/notes', { note: note }, function(response) {
            quote.notes = response.quote.notes;
        });
    }


    Quotes.share = function(quote, email, note) {
        $.post(Quotes.endpoint + 'quotes/' + quote.guid + '/share', { email: email, note:note }, function(response) {

        });
   }

    Quotes.init();
}
